import { Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public blockUIList: NgBlockUI;
  public isLoading: boolean = false;

  constructor() { }
  reloadStart(message, block) {
    if(message === null) this.isLoading = true;
    block.start(message);
  }
  reloadStop(block) {
    block.stop();
    block.isActive = false;
    block.reset();
    this.isLoading = false;
  }
  setLoadingUI(block){this.blockUIList = block}
}
